export default {"conf":"release","cdn":"https://d3m86d30627p3p.cloudfront.net/Content/R10011/dist/"}